import { z } from 'zod';
/** Pagination standard pour toutes les listes de l'API (évite les scans de table non bornés). */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export const idParamSchema = z.object({
    id: z.coerce.number().int().positive(),
});
//# sourceMappingURL=common.js.map